import { useRoot } from '-app/root'

export function useAppSettings() {
  const { settings } = useRoot()

  return settings.appSettings
}
